<h6 class="bxt-table-title">Reminders and Events</h6>
<div class="header">
    <app-bx-dropdown-radio
        [groups]="moreActions"
        [buttonLabel]="moreActionsButtonLabel"
        placement="right"
        (select)="moreActionClicked($event)"
        class="pull-right margin-bottom-10">
    </app-bx-dropdown-radio>
    <div class="new">
        <button class="btn-bx-primary" (click)="createClicked()">Create New</button>
    </div>
</div>
<div class="panel panel-white">
    <div class="panel-body">
        <div class="col-xs-12 text-center" *ngIf="months.length === 0" [hidden]="!showAddReminder">
            <h2 class="margin-top-30 margin-bottom-30"><a (click)="createClicked()">Add reminders</a> for this contact</h2>
        </div>

        <div class="timeline">
            <div class="spine"></div>
            <div *ngFor="let month of months">
                <div class="date_separator">
                    <span>{{ month.monthDate | date: 'MMMM yyyy' | uppercase }}</span>
                </div>
                <ul class="columns">
                    <li *ngFor="let item of month.items">
                        <div class="timeline_element partition-white">
                            <div class="timeline_date">
                                <div>
                                    <div class="inline-block">
                                        <span class="day text-bold">{{ item.DueDate | date: 'dd' }}</span>
                                    </div>
                                    <div class="inline-block margin-left-5">
                                        <span class="block week-day text-extra-large">{{ item.DueDate | date: 'EEEE' }}</span>
                                        <span class="block month text-large text-light">{{ item.DueDate | date: 'MMMM yyyy' }}</span>
                                    </div>
                                    <i class="far fa-bell fa-2x pull-right fa-border"></i>
                                </div>
                            </div>
                            <div class="timeline_content">{{ item.Description }}</div>
                            <div class="readmore">
                                <div class="checkbox clip-check check-success check-md pull-left text-left" [hidden]="!showChangeStatus">
                                    <input
                                        legacy-css
                                        type="checkbox"
                                        id="{{ item.ID_Reminder }}completed"
                                        [(ngModel)]="item.IsCompleted"
                                        (change)="changeStatus(item)" />
                                    <label for="{{ item.ID_Reminder }}completed"> Completed </label>
                                </div>
                                <button
                                    type="button"
                                    class="btn btn-primary btn-o"
                                    (click)="viewReminder(item)"
                                    [hidden]="!showViewReminder">
                                    <i class="ti-pencil"></i> View
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-danger btn-o"
                                    [hidden]="!showDeleteReminder"
                                    (click)="deleteReminder($event, item)">
                                    <i class="ti-trash"></i> Delete
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
